<template>
  <div class="page-wrapper">
    <Payment @tab="switchTab" v-if="tab_switch == 'payment'"></Payment>
    <Announcement @tab="switchTab" v-if="tab_switch == 'announcement'"></Announcement>
  </div>
</template>
<script>
import Announcement from "./Announcement.vue";
import Payment from "./Payment.vue"
export default {
  components: {
    Announcement,
    Payment
  },
  data: () => ({
    tab_switch: "payment",
  }),
  watch: {
    "$route.params.tab"(tab) {
      this.tab_switch = tab;
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "settings", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>
